import React from 'react'
import { IconProps } from '../../types'
import { concatClassName } from '../../utils/helpers'

export const GeneralIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 36C4.9 36 3.95867 35.6087 3.176 34.826C2.392 34.042 2 33.1 2 32V4C2 2.9 2.392 1.95867 3.176 1.176C3.95867 0.392 4.9 0 6 0H34C35.1 0 36.042 0.392 36.826 1.176C37.6087 1.95867 38 2.9 38 4V32C38 33.1 37.6087 34.042 36.826 34.826C36.042 35.6087 35.1 36 34 36H6ZM6 8H34V4H6V8ZM6 16H18V12H6V16ZM22 16H34V12H22V16ZM6 24H18V20H6V24ZM22 24H34V20H22V24Z'
      fill='#1C1B1F'
    />
  </svg>
)

export const InvestingIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 16 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.6742 15.75C11.9576 15.2 12.1742 14.621 12.3242 14.013C12.4742 13.4043 12.5492 12.775 12.5492 12.125C12.5492 10.7917 12.2576 9.57067 11.6742 8.462C11.0909 7.354 10.2992 6.43333 9.29922 5.7L6.99922 8V0H14.9992L12.6992 2.3C13.5659 3.08333 14.2576 4.01667 14.7742 5.1C15.2909 6.18333 15.5492 7.35833 15.5492 8.625C15.5492 10.1417 15.1952 11.5167 14.4872 12.75C13.7786 13.9833 12.8409 14.9833 11.6742 15.75ZM0.999219 18L3.29922 15.7C2.41589 14.9167 1.72022 13.9833 1.21222 12.9C0.703552 11.8167 0.449219 10.6417 0.449219 9.375C0.449219 7.85833 0.803552 6.48333 1.51222 5.25C2.22022 4.01667 3.16589 3.01667 4.34922 2.25C4.06589 2.8 3.84522 3.379 3.68722 3.987C3.52855 4.59567 3.44922 5.225 3.44922 5.875C3.44922 7.20833 3.74522 8.429 4.33722 9.537C4.92855 10.6457 5.71589 11.5667 6.69922 12.3L8.99922 10V18H0.999219Z'
      fill='#545A5E'
    />
  </svg>
)

export const PrivacyPolicyIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H2ZM2 16H16V4H2V16ZM4 9V7H14V9H4ZM4 13V11H10V13H4Z'
      fill='#545A5E'
    />
  </svg>
)

export const DividendsIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 38'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 38C2.9 38 1.95867 37.6087 1.176 36.826C0.392 36.042 0 35.1 0 34V12C0 10.9 0.392 9.95867 1.176 9.176C1.95867 8.392 2.9 8 4 8H12V4C12 2.9 12.392 1.958 13.176 1.174C13.9587 0.391333 14.9 0 16 0H24C25.1 0 26.042 0.391333 26.826 1.174C27.6087 1.958 28 2.9 28 4V8H36C37.1 8 38.042 8.392 38.826 9.176C39.6087 9.95867 40 10.9 40 12V34C40 35.1 39.6087 36.042 38.826 36.826C38.042 37.6087 37.1 38 36 38H4ZM16 8H24V4H16V8ZM4 34H36V12H4V34Z'
      fill='#1C1B1F'
    />
  </svg>
)
export const KYCIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 28C10.9 28 9.95867 27.6087 9.176 26.826C8.392 26.042 8 25.1 8 24V10H12V24H30V28H12ZM20 20C18.9 20 17.9587 19.608 17.176 18.824C16.392 18.0413 16 17.1 16 16V4C16 2.9 16.392 1.958 17.176 1.174C17.9587 0.391333 18.9 0 20 0H36C37.1 0 38.042 0.391333 38.826 1.174C39.6087 1.958 40 2.9 40 4V16C40 17.1 39.6087 18.0413 38.826 18.824C38.042 19.608 37.1 20 36 20H20ZM20 16H36V8H20V16ZM4 36C2.9 36 1.95867 35.6087 1.176 34.826C0.392 34.042 0 33.1 0 32V18H4V32H22V36H4Z'
      fill='#1C1B1F'
    />
  </svg>
)

export const PlatformIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 32C2.9 32 1.95867 31.6087 1.176 30.826C0.392 30.042 0 29.1 0 28V4C0 2.9 0.392 1.95867 1.176 1.176C1.95867 0.392 2.9 0 4 0H36C37.1 0 38.042 0.392 38.826 1.176C39.6087 1.95867 40 2.9 40 4V28C40 29.1 39.6087 30.042 38.826 30.826C38.042 31.6087 37.1 32 36 32H4ZM4 28H12V4H4V28ZM16 28H24V4H16V28ZM28 28H36V4H28V28Z'
      fill='#1C1B1F'
    />
  </svg>
)

export const SigningUpIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 18C15.6 18 12 14.4 12 10C12 5.6 15.6 2 20 2C24.4 2 28 5.6 28 10C28 14.4 24.4 18 20 18ZM4 36V32C4 26.48 13.2 24 20 24C26.8 24 36 26.48 36 32V36H4ZM30 10V6H34V10H38V14H34V18H30V14H26V10H30Z'
      fill='#1C1B1F'
    />
  </svg>
)

export const InvestmentTransactionsIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 2C11.16 2 4 9.16 4 18H0L6 24L12 18H8C8 11.38 13.38 6 20 6C26.62 6 32 11.38 32 18C32 24.62 26.62 30 20 30C16.7 30 13.7 28.7 11.52 26.52L8.7 29.34C11.64 32.28 15.64 34 20 34C28.84 34 36 26.84 36 18C36 9.16 28.84 2 20 2Z'
      fill='#1C1B1F'
    />
  </svg>
)

export const AccountProfileIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 18C15.6 18 12 14.4 12 10C12 5.6 15.6 2 20 2C24.4 2 28 5.6 28 10C28 14.4 24.4 18 20 18ZM4 34V30C4 24.48 13.2 22 20 22C26.8 22 36 24.48 36 30V34H4Z'
      fill='#1C1B1F'
    />
  </svg>
)

export const FeedbackComplaintsIcon = ({ width = '16', height = '18', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    className={concatClassName(classes)}
    viewBox='0 0 40 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 4C4 1.8 5.8 0 8 0H32C34.2 0 36 1.8 36 4V24C36 26.2 34.2 28 32 28H12L4 36V4ZM10 14H30V12H10V14ZM10 20H26V18H10V20Z'
      fill='#1C1B1F'
    />
  </svg>
)
